const wideMargin = "margin: -8px -8px 0 -8px;";
const standardMargin = "margin: 0 0 0 0;";

const accordionLabelMargin =
  () =>
  ({ $insideBorder }) =>
    $insideBorder ? wideMargin : standardMargin;

const inline = "";
const wideWidth = "width: calc(100% + 16px);";
const standardWidth = "width: 100%;";

const accordionLabelWidth = ({ $insideBorder, $fullWidth }) => {
  if (!$fullWidth) return inline;
  return $insideBorder ? wideWidth : standardWidth;
};

export { accordionLabelMargin, accordionLabelWidth };
